// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"e2ba2b3f","328":"71b8f6e0"}[chunkId] + ".chunk.js";
};